
import gql from 'graphql-tag'
// 查询测试
export const getAllUsers = gql`
  query($nameFilter: String) {
    getAllUsers(
      nameFilter: $nameFilter,
    ) {
      id
      username
    }
  }
`
// 修改测试
export const signIn = gql`
  mutation($password: String!, $username: String!) {
    signIn(
      password: $password,
      username: $username
    ) {
      id
    }
  }
`
// """查询订单(经销商)"""
export const findOrder = gql`
  query($orderId: Int!) {
    findOrder(
      orderId: $orderId,
    ) {
      addressId
      areaId
      bankType
      buyerMessage
      teacherName
      teacherPhone
      className
      createdAt
      dealerId
      errCode
      errCodeDes
      id
      period
      grade
      mailingAddress
      realname
      phone
      memberId
      memberUniqueId
      orderNumber
      schoolId
      status
      timeEnd
      totalPrice
      tradeType
      updatedAt
      year
      transactionNumber
      school {
        name
      }
      dealer {
        id
        realname
        storePhone
        storePhone
        user {
          phone
        }
      }
      items {
        id
        title
        count
        price
        author
        thumb
      }
      member {
        id
        nickname
      }
      profitSharing {
        bankType
        id
        profitSharingNumber
      }
    }
  }
`

// """查询订单列表(经销商)"""
export const findOrders = gql`
  query($order: [OrdersFindOrder!], $paging: PagingQuery, $where: OrdersFindFilter) {
    findOrders(
      order: $order,
      paging: $paging,
      where: $where
    ) {
      orders {
        period
        phone
        realname
        address {
          className
          isDefault
          schoolId
          updatedAt
          year
          school {
            name
            area {
              mergerName
            }
          }
        }
        dealer {
          id
          realname
          storePhone
          storePhone
          user {
            phone
          }
        }
        refund {
          auditStatus
          refundWay
        }
        areaId
        buyerMessage
        className
        createdAt
        dealerId
        errCode
        errCodeDes
        id
        items {
          id
          title
          count
          price
          author
          thumb
        }
        memberId
        member {
          id
          nickname
        }
        memberUniqueId
        orderNumber
        transactionNumber
        schoolId
        status
        timeEnd
        totalPrice
        tradeType
        updatedAt
        year
      }
      paging {
        currentOffset
        take
        totalCount
      }
      totalAmount
    }
  }
`
// 查询顶刊周期
export const findAllPeriod = gql`
  query {
    findAllUsedPeriodSettings
  }
`

export const exportOrdersList = gql`
  query($order: [OrdersFindOrder!],$where: OrdersFindFilter) {
    exportOrdersList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`

export const exportOrdersStatList = gql`
  query($order: [OrdersFindOrder!],$where: OrdersFindFilter) {
    exportOrdersStatList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
